// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__-cVcP","secondary":"Heading_secondary__dTL0w"};